import { LegalPage } from "@/components/site/LegalPage";
import { Seo, breadcrumb } from "@/components/site/Seo";

export default function Privacy() {
  return (
    <>
    <Seo title="Privacy Policy — OpenDegree" description="How OpenDegree handles personal data for learners and education providers, in line with UK GDPR." path="/privacy" jsonLd={breadcrumb([{ name: "Home", path: "/" }, { name: "Privacy Policy", path: "/privacy" }])} />
    <LegalPage
      testid="privacy-page"
      title="Privacy Policy"
      updated="June 2026"
      intro="OpenDegree is committed to protecting the privacy of students and education providers. This placeholder outlines how we intend to handle personal data once our platform launches."
      sections={[
        { h: "Information We Collect", p: "When live, OpenDegree will collect profile details, qualifications, documents and preferences that students choose to share in order to match them with suitable universities." },
        { h: "How We Use Information", p: "Data will be used to power AI matching, complete and track applications, and share relevant details with the higher education providers a student chooses to apply to." },
        { h: "Data Security", p: "We plan to store personal data securely, using industry-standard encryption and access controls. Documents are uploaded once and reused only with consent." },
        { h: "Your Rights", p: "Students will be able to access, correct and delete their data, and control which providers can view their profile, in line with UK GDPR." },
        { h: "Contact", p: "For any privacy questions, please email hello@opendegree.co.uk. This policy will be finalised prior to public launch." },
      ]}
    />
    </>
  );
}
